import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { caxios } from "../../config/config";
import styles from "./Login.module.css";

const Login = () => {
  const navigate = useNavigate();

  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await caxios.post("/auth/login", {
        id: id,
        pw: pw
      });

      console.log(res);
      // 받아온 토큰 저장
      const token = res.data.token;

      sessionStorage.setItem("token", token);

      // 로그인 성공 시 이동
      navigate("/");

    } catch (err) {
      console.error(err);
      setError("아이디 또는 비밀번호가 올바르지 않습니다.");
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) return;

    const verify = async () => {
      try {
        await caxios.get("/auth/verify"); // 서버에서 JWT 검증
        navigate("/"); // ✅ 로그인 상태면 바로 홈으로 이동
      } catch (err) {
        sessionStorage.removeItem("token"); // ❌ 위조/만료 토큰이면 삭제
      }
    };

    verify();
  }, [navigate]);

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h2 className={styles.title}>로그인</h2>

        <form className={styles.form} onSubmit={onSubmit}>

          <div className={styles.formGroup}>
            <label className={styles.label}>아이디</label>
            <input
              type="text"
              className={styles.input}
              value={id}
              onChange={(e) => setId(e.target.value)}
              placeholder="아이디를 입력하세요"
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>비밀번호</label>
            <input
              type="password"
              className={styles.input}
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              placeholder="비밀번호를 입력하세요"
            />
          </div>

          {error && <p className={styles.error}>{error}</p>}

          <button type="submit" className={styles.loginButton}>
            로그인
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
